module.exports = __webpack_public_path__ + "static/etf-equivalent-gif-0dccc0dd364412adb3b86543e3d8f662.gif";